.container {
  width: 100%;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
}

.editor {
  overflow: auto;
  min-height: 150px;
  resize: none;
  border: 1px solid #d1d5db; /* Tailwind's gray-300 */
  padding: 0.5rem;
  border-radius: 0.375rem;
  background-color: #fff;
  font-size: 14px;
  line-height: 1.6;
}

.toolbarButton {
  margin-left: 0.5rem;
  padding: 0.25rem;
  border: none;
  border-radius: 0.375rem;
  background-color: #e5e7eb; /* Tailwind's gray-200 */
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
}

.toolbarButton:hover {
  background-color: #d1d5db; /* Tailwind's gray-300 */
}

.hiddenFileInput {
  display: none;
}
